import { AppService } from './../../../../../core/app.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RegroupementActiviteRes } from '../../../../../data/http/responses/regroupementactivities.res';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { LigneBudgetaireResponse } from '../../../../../data/http/responses/lignebudgetaire.res';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LigneBudgetaireService } from '../../../../../services/lignebudgetaire/lignebudgetaire.service';
import { StructureService } from '../../../../../services/StructureService';
import { ActiviteService } from '../../../../../services/activite/activite.service';
import { ActivtieResponse } from '../../../../../data/http/responses/activite.response';
import { toSnakeCaseUpper } from '../../../../../utils/helpers';
import { RegroupementActiviteReq } from '../../../../../data/http/requests/regroupementactivities.req';
import { RegroupementActiviteService } from '../../../../../services/regroupementactivities.service';
import { routeAlias } from '../../../../../../routesalias';
import { MatIcon } from '@angular/material/icon';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { Input } from '../../../../../components/forms/input/input';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { SelectComponent } from '../../../../../components/forms/select/select.component';
import { SteponeactivitiesComponent } from '../../../../../components/activities/steponeactivities/steponeactivities.component';
import { SteptwoactivitiesComponent } from '../../../../../components/activities/steptwoactivities/steptwoactivities.component';
import { StepthreeactivitiesComponent } from '../../../../../components/activities/stepthreeactivities/stepthreeactivities.component';
import { StepfouractivitiesComponent } from '../../../../../components/activities/stepfouractivities/stepfouractivities.component';
import { CommonModule } from '@angular/common';
import { RecapactivitiesComponent } from '../../../../../components/activities/recapactivities/recapactivities.component';
import { StepperState } from '../../activity/add/add.component';
import { Subscription } from 'rxjs';
import { UiButtonComponent } from '../../../../../components/button/button.component';

@Component({
  selector: 'app-add',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SteponeactivitiesComponent,
    SteptwoactivitiesComponent,
    StepthreeactivitiesComponent,
    StepfouractivitiesComponent,
    CommonModule,
    RecapactivitiesComponent,
    LoaderComponent,
    MatIcon,
    SelectComponent,
    RouterLink,
    UiButtonComponent
  ],
  templateUrl: './add.component.html',
  styleUrl: './add.component.css'
})
export class AddRegroupementActivitePage implements OnInit, OnDestroy {

  baseSteps = [
    { id: 'generales', label: 'Informations Générales' },
    { id: 'activites', label: "Informations sur l'Activités" },
    { id: 'budgets',   label: "Informations sur le budget de l'activité" },
    { id: 'recap',     label: 'Récapitulatif' }
  ];
  steps: { id: string; label: string }[] = [];

  activeStepId: string = '';
  activity: any = {
    generales: { typeInterventionSelect: '', typeActivitySelect: '' },
    activites: {},
    budgets: {},
    stepfour: {}
  };

  public showPmpStep: boolean = false;
  private isTypeNouvelleActivite: boolean = false;
  private isModePmp: boolean = false;
  public completedSteps: string[] = [];

  private queryParamsSubscription: Subscription | undefined;
  private stepperStateKey = 'activityStepperState';
  private activityDataKey = 'activity';

  public isLoading: boolean = false;
  public entities: RegroupementActiviteRes[] = [];
  public entityForm: FormGroup = new FormGroup({});
  public structureData: SelectOption[] = [];
  public ligneBudgetaires: SelectOption[] = [];
  public activities: SelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private AppService: AppService,
    private ligneBudgetaireService: LigneBudgetaireService,
    private structureService: StructureService,
    private activiteService: ActiviteService,
    private regroupementActiviteService: RegroupementActiviteService
  ) {
    this.entityForm = this.fb.group({
      activitesSelectionnees: this.fb.array([]),
      applicationId: this.AppService.getAppId()!,
      complementaryInfo: this.fb.group({})
    });
  }

  ngOnInit(): void {
    this.loadActivities();
    this.loadLigneBudgetaire();
    this.loadStructures();

    const storedActivity = localStorage.getItem(this.activityDataKey);
    if (storedActivity) {
      this.activity = JSON.parse(storedActivity);
      this.isTypeNouvelleActivite = this.activity.generales?.typeActivitySelect === 'Nouvelle activité';
      this.isModePmp = this.isTypeNouvelleActivite && this.isModePmp;
    } else {
      this.activity = {
        generales: { typeInterventionSelect: '', typeActivitySelect: '' },
        activites: {},
        budgets: {},
        stepfour: {}
      };
    }

    // Stepper inactif par défaut — s'active via checkStepperActivation() dès ≥ 2 activités
    this.activeStepId = '';
    this.completedSteps = [];
    this.showPmpStep = false;
    this.updateStepsArray();

    // Navigation entre étapes
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      const requestedStepId = params['step'];

      // Ignorer si le stepper n'est pas encore actif
      if (!this.activeStepId) return;

      const currentStepIndex = this.steps.findIndex(s => s.id === requestedStepId);

      const isRecapAvailable = requestedStepId === 'recap' &&
        ((!this.showPmpStep && this.completedSteps.includes('budgets')) ||
          (this.showPmpStep && this.completedSteps.includes('stepfour')));

      if (requestedStepId && currentStepIndex !== -1) {
        const isStepAvailable =
          this.completedSteps.includes(requestedStepId) ||
          requestedStepId === this.activeStepId ||
          isRecapAvailable;

        if (isStepAvailable) {
          this.activeStepId = requestedStepId;
        } else {
          this.router.navigate([], {
            queryParams: { step: this.activeStepId },
            relativeTo: this.route,
            replaceUrl: true
          });
        }
      } else {
        this.router.navigate([], {
          queryParams: { step: this.activeStepId },
          relativeTo: this.route,
          replaceUrl: true
        });
      }

      this.saveStepperState();
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
  }

  // ── Progression ───────────────────────────────
  getActiveStepIndex(): number {
    return this.steps.findIndex(s => s.id === this.activeStepId);
  }

  getProgressPercent(): number {
    const total = this.steps.length;
    if (total <= 1) return 0;
    return Math.round((this.getActiveStepIndex() / (total - 1)) * 100);
  }

  // ── Getters ───────────────────────────────────
  get activitesFormArray(): FormArray {
    return this.entityForm.get('activitesSelectionnees') as FormArray;
  }

  get complementaryInfoFormGroup(): FormGroup {
    return this.entityForm.get('complementaryInfo') as FormGroup;
  }

  // ── FormArray ─────────────────────────────────
  addActivity(): void {
    this.activitesFormArray.push(this.fb.control('', Validators.required));
    this.checkStepperActivation();
  }

  removeActivity(index: number): void {
    if (this.activitesFormArray.length > 1) {
      this.activitesFormArray.removeAt(index);
      this.checkStepperActivation();
    }
  }

  getAvailableActivities(index: number): SelectOption[] {
    const selectedIds = this.activitesFormArray.value as string[];
    const currentId   = this.activitesFormArray.at(index).value as string;
    return this.activities.filter(a => !selectedIds.includes(a.value) || a.value === currentId);
  }

  private checkStepperActivation(): void {
    if (this.activitesFormArray.length >= 2) {
      if (!this.activeStepId) {
        this.activeStepId = this.baseSteps[0].id;
        this.updateStepsArray();
        this.completedSteps = [];
        this.saveStepperState();
        // ✅ Navigation explicite → déclenche le queryParamsSubscription → affiche le stepper
        this.router.navigate([], {
          queryParams: { step: this.activeStepId },
          relativeTo: this.route
        });
      }
    } else {
      this.activeStepId = '';
      this.steps = [];
      this.completedSteps = [];
      this.saveStepperState();
      // Nettoyer l'URL
      this.router.navigate([], {
        queryParams: {},
        relativeTo: this.route,
        replaceUrl: true
      });
    }
  }

  // ── Données ───────────────────────────────────
  loadStructures(): void {
    this.structureService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.structureData = response.data.map((item: StructureResponse) => ({
          value: item.code,
          label: item.code
        }));
      },
      error: (error) => console.error('Erreur structures :', error)
    });
  }

  loadLigneBudgetaire(): void {
    this.ligneBudgetaireService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.ligneBudgetaires = response.data.map((item: LigneBudgetaireResponse) => ({
          value: item.libelle,
          label: item.libelle
        }));
      },
      error: (error) => console.error('Erreur lignes budgétaires :', error)
    });
  }

  loadActivities(): void {
    this.activiteService.getAllByAppIdExcludeRegroupement(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.activities = response.data.map((item: ActivtieResponse) => ({
          value: item.id,
          label: item.titre
        }));
      },
      error: (error) => console.error('Erreur activités :', error)
    });
  }

  // ── Stepper ───────────────────────────────────
  private updateStepsArray(): void {
    this.steps = [...this.baseSteps];
    if (this.showPmpStep) {
      const recapIndex = this.steps.findIndex(s => s.id === 'recap');
      if (recapIndex !== -1) {
        this.steps.splice(recapIndex, 0, { id: 'stepfour', label: 'Informations Marché' });
      } else {
        this.steps.push({ id: 'stepfour', label: 'Informations Marché' });
      }
    }
  }

  private saveStepperState(): void {
    const state: StepperState = {
      activeStepId:   this.activeStepId,
      completedSteps: this.completedSteps,
      showPmpStep:    this.isTypeNouvelleActivite && this.isModePmp
    };
    localStorage.setItem(this.stepperStateKey, JSON.stringify(state));
  }

  updateActivity(stepData: any, stepId: string): void {
    if (stepId === 'generales')      this.activity.generales = stepData;
    else if (stepId === 'activites') this.activity.activites = stepData;
    else if (stepId === 'budgets')   this.activity.budgets   = stepData;
    else if (stepId === 'stepfour')  this.activity.stepfour  = stepData;

    localStorage.setItem(this.activityDataKey, JSON.stringify(this.activity));

    if (!this.completedSteps.includes(stepId)) {
      this.completedSteps.push(stepId);
    }

    const currentStepIndex = this.steps.findIndex(s => s.id === stepId);
    if (currentStepIndex !== -1 && currentStepIndex < this.steps.length - 1) {
      const nextStepId = this.steps[currentStepIndex + 1].id;
      this.activeStepId = nextStepId;
      this.router.navigate([], { queryParams: { step: nextStepId }, relativeTo: this.route });
    } else if (currentStepIndex === this.steps.length - 1 && stepId !== 'recap') {
      const recapStep = this.steps.find(s => s.id === 'recap');
      if (recapStep) {
        this.activeStepId = 'recap';
        this.router.navigate([], { queryParams: { step: 'recap' }, relativeTo: this.route });
      }
    }

    this.saveStepperState();
  }

  handleTypeActivityChange(isNouvelleActivite: boolean): void {
    this.isTypeNouvelleActivite = isNouvelleActivite;
    this.updatePmpStepVisibility();
  }

  handlePmpModeChange(isPmp: boolean): void {
    this.isModePmp = isPmp;
    this.updatePmpStepVisibility();
  }

  private updatePmpStepVisibility(): void {
    const shouldShow = this.isTypeNouvelleActivite && this.isModePmp;
    if (this.showPmpStep === shouldShow) return;

    this.showPmpStep = shouldShow;
    this.updateStepsArray();

    if (!this.showPmpStep && this.activeStepId === 'stepfour') {
      this.activeStepId = 'budgets';
      this.activity.stepfour = {};
      localStorage.setItem(this.activityDataKey, JSON.stringify(this.activity));
      this.router.navigate([], {
        queryParams: { step: 'budgets' },
        relativeTo: this.route,
        replaceUrl: true
      });
    }

    this.saveStepperState();
  }

  // ── Soumission ────────────────────────────────
  handleFinalSubmit(): void {
    this.onSubmitActivity();
  }

  onSubmitActivity(): void {
    const caracteristiquesArray: { code: string; valeur: any }[] = [];

    const excludedFieldForActivites = ['structureAssociee'];
    Object.keys(this.activity.activites).forEach(key => {
      if (!excludedFieldForActivites.includes(key)) {
        caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.activites[key] ?? '' });
      }
    });

    if (this.activity.activites.structureAssociee && Array.isArray(this.activity.activites.structureAssociee)) {
      this.activity.activites.structureAssociee.forEach((structureId: string) => {
        caracteristiquesArray.push({ code: 'STRUCTASSOCIE', valeur: structureId ?? '' });
      });
    }

    Object.keys(this.activity.budgets).forEach(key => {
      caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.budgets[key] ?? '' });
    });

    Object.keys(this.activity.stepfour).forEach(key => {
      caracteristiquesArray.push({ code: toSnakeCaseUpper(key), valeur: this.activity.stepfour[key] ?? '' });
    });

    caracteristiquesArray.push({ code: 'TYPE_ACTIVITE', valeur: this.activity.generales.typeActivitySelect ?? '' });

    const monthNames = ['JANVIER','FEVRIER','MARS','AVRIL','MAI','JUIN','JUILLET','AOUT','SEPTEMBRE','OCTOBRE','NOVEMBRE','DECEMBRE'];
    const transformedTaches: any[] = [];

    if (this.activity.generales.taches && Array.isArray(this.activity.generales.taches)) {
      this.activity.generales.taches.forEach((tache: any) => {
        const tacheCaracteristiques: { code: string; valeur: any }[] = [];
        if (tache.poids !== undefined) {
          tacheCaracteristiques.push({ code: 'POIDS', valeur: tache.poids ?? '' });
        }
        if (tache.chronogrammes && Array.isArray(tache.chronogrammes)) {
          tache.chronogrammes.forEach((isScheduled: boolean, index: number) => {
            if (index < monthNames.length) {
              tacheCaracteristiques.push({ code: monthNames[index], valeur: !!isScheduled });
            }
          });
        }
        transformedTaches.push({ titre: tache.titreTache ?? '', caracteristiques: tacheCaracteristiques });
      });
    }

    const trueSendingActivity = {
      parent:           this.activity.generales.typeInterventionSelect ?? '',
      titre:            this.activity.generales.activities ?? '',
      objectif:         this.activity.generales.description ?? '',
      typeActivite:     'ACTIVITE',
      caracteristiques: caracteristiquesArray,
      taches:           transformedTaches,
      applicationId:    this.AppService.getAppId()!,
      regroupements:    this.entityForm.value.activitesSelectionnees,
    };

    if (this.entityForm.valid && this.entityForm.value.activitesSelectionnees.length >= 2 && this.activity != null) {
      this.isLoading = true;
      this.regroupementActiviteService.create(trueSendingActivity).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate([routeAlias.activities.home, routeAlias.activities.activity.home]);
        },
        error: (error) => {
          console.error('Erreur lors de la création :', error);
          this.isLoading = false;
        }
      });
    }
  }
}